import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { ITrainerHorseListPageState } from "interfaces/ITrainerHorseListPageState";

const base = "TRAINER_HORSE_LIST_PAGE";
export const SET_SELECTED_FACILITY = `${base}_SET_SELECTED_FACILITY`;
export const SET_SEARCH_QUERY = `${base}_SET_SEARCH_QUERY`;
export const SET_LIST_HORSES_REQUEST_KEY = `${base}SET_LIST_HORSES_REQUEST_KEY`;

export interface ITrainerHorseListPageType extends ITrainerHorseListPageState {
  type: string;
}

export const setSelectedFacility = (
  selectedFacility: racehorse360.IFacility
): Partial<ITrainerHorseListPageType> => {
  return {
    type: SET_SELECTED_FACILITY,
    selectedFacility
  };
};

export const setSearchQuery = (
  searchQuery: string
): Partial<ITrainerHorseListPageType> => {
  return {
    type: SET_SEARCH_QUERY,
    searchQuery
  };
};

export const setListHorsesRequestKey = (
  listHorsesRequestKey: (string | object)[]
): Partial<ITrainerHorseListPageType> => {
  return {
    type: SET_LIST_HORSES_REQUEST_KEY,
    listHorsesRequestKey
  };
};
